/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { toolsList } from "../funcs/toolsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListToolsResult } from "../models/components/listtoolsresult.js";
import {
  ListToolsRequest,
  ListToolsSecurity,
  ToolTypes,
} from "../models/operations/listtools.js";
import { unwrapAsync } from "../types/fp.js";
export type ListToolsQueryData = ListToolsResult;

export function prefetchListTools(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListToolsRequest | undefined,
  security?: ListToolsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListToolsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListToolsQuery(
  client$: GramCore,
  request?: ListToolsRequest | undefined,
  security?: ListToolsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListToolsQueryData>;
} {
  return {
    queryKey: queryKeyListTools({
      cursor: request?.cursor,
      limit: request?.limit,
      deploymentId: request?.deploymentId,
      urnPrefix: request?.urnPrefix,
      toolTypes: request?.toolTypes,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function listToolsQueryFn(ctx): Promise<ListToolsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(toolsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListTools(
  parameters: {
    cursor?: string | undefined;
    limit?: number | undefined;
    deploymentId?: string | undefined;
    urnPrefix?: string | undefined;
    toolTypes?: Array<ToolTypes> | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "tools", "list", parameters];
}
